import React, { useEffect, useRef } from "react";

/**
 * Minimal custom cursor — fast, simple, no jumps on click.
 * White dot follows mouse exactly; ring lerps slightly behind. No press animation.
 */
export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const pos = useRef({ x: 0, y: 0 });
  const ring = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    if (isTouch) return;
    document.documentElement.classList.add("bbf-cursor-on");

    const onMove = (e) => {
      pos.current.x = e.clientX;
      pos.current.y = e.clientY;
    };

    window.addEventListener("mousemove", onMove, { passive: true });

    let raf = 0;
    const tick = () => {
      if (dotRef.current) {
        dotRef.current.style.transform =
          `translate3d(${pos.current.x}px, ${pos.current.y}px, 0) translate(-50%, -50%)`;
      }
      // small lerp for the outer ring so it has a soft trailing feel
      ring.current.x += (pos.current.x - ring.current.x) * 0.32;
      ring.current.y += (pos.current.y - ring.current.y) * 0.32;
      if (ringRef.current) {
        ringRef.current.style.transform =
          `translate3d(${ring.current.x}px, ${ring.current.y}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("bbf-cursor-on");
    };
  }, []);

  if (typeof window === "undefined") return null;

  return (
    <div className="bbf-cursor-layer" aria-hidden="true" data-testid="custom-cursor">
      <span ref={ringRef} className="bbf-cursor-ring" />
      <span ref={dotRef} className="bbf-cursor-dot" />
    </div>
  );
}
